import React, { useEffect, useState } from "react";
import { ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import {
  getTeamMembers,
  getTeamMilestone,
  getTeamProject,
  postTeamMilestone,
} from "../../../../../redux/team/action";
import { getPriority } from "../../../../../redux/categary/action";
import ReactSelect from "react-select";
import FileUpload1 from "./FileUpload1";
import { today } from "../../../../../CloudStorage/CommonFunction";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import {
  descriptionvalidation,
  titlevalidation,
} from "../../../../Common/commonvalidation";
import TimePickerRSuite from "../../../../Common/TimePickerRSuite";
import AsteriskLabel from "../../../../Common/AsteriskLabel";

export default function CalenderTeamsAddTaskModel({ setModel }) {
  const [work_sample, setWork_sample] = useState(null);
  const [formData, setFormData] = useState(null);
  const [priorityindex, setpriorityindex] = useState(null);
  const [assignindex, setassignindex] = useState(null);
  const [milestoneindex, setmilestoneindex] = useState(null);
  const [projectindex, setprojectindex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileUploadProgress, setFileUploadProgress] = useState([]);
  const dispatch = useDispatch();

  // ✅ Updated validation schema with local time check only
  const validationSchema = Yup.object().shape({
    title: titlevalidation,
    team_milestone_id: Yup.string().required("Milestone is required"),
    priority_id: Yup.string().required("Priority option is required"),
    team_project_id: Yup.string().required("Project is required"),
    expert_id: Yup.string().required("Expert is required"),
    due_date: Yup.date().required("Due date is required"),
    due_time: Yup.string()
      .required("Start time is required")
      .test(
        "not-past-time",
        "Start time cannot be in the past",
        function (value) {
          const { due_date } = this.parent;
          if (!value || !due_date) return true;

          const [hours, minutes] = value.split(":").map(Number);
          const selectedDateTime = new Date(due_date);
          selectedDateTime.setHours(hours, minutes, 0, 0);

          const now = new Date();

          // If selected date is today, ensure time is not in the past
          if (
            selectedDateTime.toDateString() === now.toDateString() &&
            selectedDateTime < now
          ) {
            return false;
          }

          return true;
        }
      ),
    description: descriptionvalidation,
    files: Yup.mixed().required("A file is required"),
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      priority_id: "",
      expert_id: "",
      due_date: "",
      due_time: "",
      description: "",
      files: "",
      team_project_id: "",
      team_milestone_id: "",
    },
    validationSchema,
    onSubmit: (values) => {
      setLoading(true);
      const data = {
        type: 3,
        team_project_id: values.team_project_id,
        title: values.title,
        team_milestone_id: values.team_milestone_id,
        priority_id: values.priority_id,
        expert_id: values.expert_id,
        due_date: values.due_date,
        due_time: values.due_time,
        description: values.description,
        files: values?.files,
      };
      dispatch(postTeamMilestone(data));
      setModel((state) => !state);
      setLoading(false);
    },
  });

  // Sync formData if provided
  useEffect(() => {
    if (formData) {
      formik.setValues(formData);
    }
  }, [formData]);

  const allmembers = useSelector(({ team: { getteammemberss } }) => getteammemberss);
  const allperiority = useSelector(({ categary: { prioritylist } }) => prioritylist);
  const allmilestone = useSelector(({ team: { getteammilestones } }) => getteammilestones);
  const projectlists = useSelector(({ team: { getteamprojects } }) => getteamprojects);

  useEffect(() => {
    dispatch(getPriority());
    dispatch(getTeamMembers("", ""));
    dispatch(getTeamProject());
  }, [dispatch]);

  useEffect(() => {
    if (formik?.values?.team_project_id) {
      dispatch(getTeamMilestone(formik?.values?.team_project_id));
    }
  }, [formik?.values?.team_project_id, dispatch]);

  useEffect(() => {
    setWork_sample(work_sample);
  }, [work_sample]);

  useEffect(() => {
    if (work_sample) {
      formik.setFieldValue("files", work_sample);
    }
  }, [work_sample]);

  return (
    <>
      <div className="add-task">
        <h6>Add Calendar Task</h6>
        <button
          onClick={() => setModel((state) => !state)}
          className="btn close-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt=""
          />
        </button>
      </div>
      <ModalBody>
        <div>
          <div className="">
            <form onSubmit={formik.handleSubmit}>
              {/* Project */}
              <div className="form-group">
                <label className="label">Project *</label>
                <ReactSelect
                  options={
                    Array.isArray(projectlists) &&
                    projectlists.map((lang) => ({
                      value: lang.id,
                      label: lang.title,
                    }))
                  }
                  placeholder={"Select Project"}
                  value={projectindex}
                  onChange={(options) => {
                    setprojectindex(options);
                    formik.setFieldValue("team_project_id", options.value);
                  }}
                />
                {formik.touched.team_project_id &&
                  formik.errors.team_project_id && (
                    <div style={{ color: "red" }}>
                      {formik.errors.team_project_id}
                    </div>
                  )}
              </div>

              {/* Title */}
              <div className="form-group">
                <label className="label">Task Title *</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  placeholder="Enter Title"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.title && formik.errors.title && (
                  <div style={{ color: "red" }}>{formik.errors.title}</div>
                )}
              </div>

              {/* Description */}
              <div className="form-group">
                <label className="label">Description *</label>
                <textarea
                  name="description"
                  className="form-control"
                  placeholder="Describe what task is about"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.description && formik.errors.description && (
                  <div style={{ color: "red" }}>
                    {formik.errors.description}
                  </div>
                )}
              </div>

              {/* Assign to */}
              <div className="form-group">
                <label className="label">Assign to *</label>
                <ReactSelect
                  options={
                    Array.isArray(allmembers) &&
                    allmembers.map((lang) => ({
                      value: lang.expert_id,
                      label: `${lang.first_name} ${lang.last_name}`,
                    }))
                  }
                  placeholder={"Search for assignee"}
                  value={assignindex}
                  onChange={(options) => {
                    setassignindex(options);
                    formik.setFieldValue("expert_id", options.value);
                  }}
                />
                {formik.touched.expert_id && formik.errors.expert_id && (
                  <div style={{ color: "red" }}>{formik.errors.expert_id}</div>
                )}
              </div>

              {/* Due Date */}
              <div className="form-group">
                <label className="label">Due Date *</label>
                <input
                  type="date"
                  name="due_date"
                  className="form-control"
                  value={formik.values.due_date}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  min={today}
                />
                {formik.touched.due_date && formik.errors.due_date && (
                  <div style={{ color: "red" }}>{formik.errors.due_date}</div>
                )}
              </div>

              {/* Due Time */}
              <div className="form-group">
                <label>
                  Due Time <AsteriskLabel />
                </label>
                <TimePickerRSuite
                  formik={formik}
                  name={`due_time`}
                  label=""
                  selectedDate={formik?.values?.due_time}
                />
                <br />
                {formik.touched.due_time && formik.errors.due_time && (
                  <div style={{ color: "red" }}>{formik.errors.due_time}</div>
                )}
              </div>

              {/* Priority */}
              <div className="form-group">
                <label className="label">Set Priority *</label>
                <ReactSelect
                  options={
                    Array.isArray(allperiority) &&
                    allperiority.map((lang) => ({
                      value: lang.id,
                      label: lang.title,
                    }))
                  }
                  placeholder={"Select An Option"}
                  value={priorityindex}
                  onChange={(options) => {
                    setpriorityindex(options);
                    formik.setFieldValue("priority_id", options.value);
                  }}
                />
                {formik.touched.priority_id && formik.errors.priority_id && (
                  <div style={{ color: "red" }}>
                    {formik.errors.priority_id}
                  </div>
                )}
              </div>

              {/* Milestone */}
              <div className="form-group">
                <label className="label">Milestone *</label>
                <ReactSelect
                  options={
                    Array.isArray(allmilestone) &&
                    allmilestone.map((lang) => ({
                      value: lang.id,
                      label: lang.title,
                    }))
                  }
                  placeholder={"Select Milestone"}
                  value={milestoneindex}
                  onChange={(options) => {
                    setmilestoneindex(options);
                    formik.setFieldValue("team_milestone_id", options.value);
                  }}
                />
                {formik.errors.team_milestone_id && (
                  <div style={{ color: "red" }}>
                    {formik.errors.team_milestone_id}
                  </div>
                )}
              </div>

              {/* Files */}
              <div className="form-group">
                <label className="label">Files *</label>
                <FileUpload1
                  setWork_sample={setWork_sample}
                  worksampleFiles={work_sample}
                />
                {formik.touched.files && formik.errors.files && (
                  <div style={{ color: "red" }}>{formik.errors.files}</div>
                )}
              </div>
            </form>
          </div>
        </div>
      </ModalBody>

      <div className="modal-footer mt-3">
        <button
          className="btn"
          onClick={() => formik.handleSubmit()}
          disabled={loading}
        >
          {loading ? <LoginLoaderButton /> : "Save"}
        </button>
      </div>
    </>
  );
}
